import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Hidden } from "@mui/material";
import TopBar from "./TopBar";
import { AppSideBar } from "./SideBar";
import { useAuthContext } from "../../AuthContextWrapper";
import { ContentWrapper } from "../../components/ContentWrapper";
import { AuthCircle } from "../../components/AuthCircle";

const drawerWidth = 200;

export const AppLayout = (): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { setFlow } = useAuthContext()

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // exit flow
  window.setTimeout(() => {
    setFlow && setFlow(undefined);
  }, 0);

  return (
    <Box sx={{ display: "flex" }}>
      <TopBar onMobileNavOpen={handleDrawerToggle} elevation={0} />
      <AppSideBar
        drawerWidth={drawerWidth}
        openMobile={mobileOpen}
        onMobileClose={handleDrawerToggle}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: {
            md: 3,
            sm: 2,
            xs: 2,
          },
          pl: {
            md: 4,
            sm: 2,
            xs: 2,
          },
          pt: {
            sm: 9,
            xs: 9,
          },
          width: { md: `calc(100% - ${drawerWidth}px)` },
          backgroundColor: "#F9FAFE",
        }}
      >
        <ContentWrapper>
          <>
            <Hidden mdDown>
              <AuthCircle />
            </Hidden>
            <Outlet />
          </>
        </ContentWrapper>
      </Box>
    </Box>
  );
};
